import React from 'react';
import { Typography } from '@mui/material';

import { ConfirmationDialog } from './ConfirmationDialog';

export function DeletePresetDialog(props: { onClose(): void; onDeleteConfirmed(): Promise<void> }) {
  return (
    <ConfirmationDialog
      cancelMessage="Cancel"
      onCancel={props.onClose}
      confirmMessage="Delete"
      onConfirm={() => props.onDeleteConfirmed().finally(() => props.onClose())}
    >
      <Typography>Are you sure you want to delete this preset?</Typography>
    </ConfirmationDialog>
  );
}
